import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import StarIcon from '@mui/icons-material/Star';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import CelebrationIcon from '@mui/icons-material/Celebration';
import DiamondIcon from '@mui/icons-material/Diamond';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import GroupsIcon from '@mui/icons-material/Groups';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HomeHealthIcon from '@mui/icons-material/HealthAndSafety';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SynagogueIcon from '@mui/icons-material/Synagogue';
// ── אייקונים מכובדים / יוקרה / מלכות ────────────────────────────────────
import GavelIcon from '@mui/icons-material/Gavel';
import BalanceIcon from '@mui/icons-material/Balance';
import ShieldIcon from '@mui/icons-material/Shield';
import FlareIcon from '@mui/icons-material/Flare';
import FilterVintageIcon from '@mui/icons-material/FilterVintage';
import SpaIcon from '@mui/icons-material/Spa';
import WbIncandescentIcon from '@mui/icons-material/WbIncandescent';
import AnchorIcon from '@mui/icons-material/Anchor';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import GradeIcon from '@mui/icons-material/Grade';

// ── כתרים — SVG מותאם (MUI אין כתר מובנה) ─────────────────────────────────
/** כתר קלאסי — 3 שיאים */
const CrownClassicIcon = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M5 20h14v2H5v-2zm0-2L7 6l3 7 2-11 2 11 3-7 2 12H5z" />
  </SvgIcon>
);

/** כתר מלכותי — 5 שיאים */
const CrownRoyalIcon = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M3 20h18v2H3v-2zm0-2L4 9l2 5 2-9 2 7 2-7 2 9 2-5 1 9H3z" />
  </SvgIcon>
);

/** כתר מפואר — 3 שיאים עם גולות נוי */
const CrownOrnateIcon = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M5 20h14v2H5v-2zm0-2L7 7l3 7 2-10 2 10 3-7 2 12H5z" />
    <circle cx="7" cy="6" r="1.5" />
    <circle cx="12" cy="2" r="1.5" />
    <circle cx="17" cy="6" r="1.5" />
  </SvgIcon>
);

/**
 * רשימת איקונים זמינים לווידג'ט נציב הקהילה
 * כל איקון מתאים לסוגים שונים של הוקרה והנצחה
 */
export const iconOptions = [
    {
        id: 'star',
        label: 'כוכב',
        icon: StarIcon,
        description: 'מתאים לנציב היום, הוקרה כללית'
    },
    {
        id: 'heart',
        label: 'לב',
        icon: FavoriteIcon,
        description: 'מתאים לעילוי נשמה, אהבה והוקרה'
    },
    {
        id: 'flower',
        label: 'פרח',
        icon: LocalFloristIcon,
        description: 'מתאים להנצחה, זיכרון'
    },
    {
        id: 'sparkle',
        label: 'ניצוץ',
        icon: AutoAwesomeIcon,
        description: 'מתאים למצטיינים, הישגים מיוחדים'
    },
    {
        id: 'trophy',
        label: 'גביע',
        icon: EmojiEventsIcon,
        description: 'מתאים לזוכים, הצטיינות'
    },
    {
        id: 'hands',
        label: 'ידיים נותנות',
        icon: VolunteerActivismIcon,
        description: 'מתאים לתורמים, נדיבות'
    },
    {
        id: 'celebration',
        label: 'חגיגה',
        icon: CelebrationIcon,
        description: 'מתאים לאירועים מיוחדים, שמחות'
    },
    {
        id: 'diamond',
        label: 'יהלום',
        icon: DiamondIcon,
        description: 'מתאים לאישיות יקרת ערך'
    },
    {
        id: 'premium',
        label: 'תג פרימיום',
        icon: WorkspacePremiumIcon,
        description: 'מתאים לחברי כבוד, הוקרה מיוחדת'
    },
    {
        id: 'medal',
        label: 'מדליה',
        icon: MilitaryTechIcon,
        description: 'מתאים לאבות ובנים, הצטיינות'
    },
    {
        id: 'book',
        label: 'ספר פתוח',
        icon: MenuBookIcon,
        description: 'מתאים ללומדי תורה, התקדמות בלימוד'
    },
    {
        id: 'stories',
        label: 'דפדוף בספר',
        icon: AutoStoriesIcon,
        description: 'מתאים להתמדה בלימוד, קריאה רציפה'
    },
    {
        id: 'quill',
        label: 'קולמוס ודף',
        icon: HistoryEduIcon,
        description: 'מתאים לכתיבת חידושים, סופרי סת"ם'
    },
    {
        id: 'groups',
        label: 'קבוצת אנשים',
        icon: GroupsIcon,
        description: 'מתאים למשפחת השבוע, פעילות קהילתית'
    },
    {
        id: 'unity',
        label: 'אחדות',
        icon: Diversity1Icon,
        description: 'מתאים לאחדות, ערבות הדדית, חיבור'
    },
    {
        id: 'handshake',
        label: 'לחיצת ידיים',
        icon: HandshakeIcon,
        description: 'מתאים לשיתופי פעולה, תרומה הדדית'
    },
    {
        id: 'health',
        label: 'בית עם לב',
        icon: HomeHealthIcon,
        description: 'מתאים לביקור חולים, עזרה בקהילה'
    },
    {
        id: 'verified',
        label: 'מגן מאומת',
        icon: VerifiedUserIcon,
        description: 'מתאים לנאמן הקהילה, חבר מוסמך'
    },
    {
        id: 'pillars',
        label: 'עמודים',
        icon: AccountBalanceIcon,
        description: 'מתאים ליסודות הקהילה, בית הכנסת'
    },
    {
        id: 'synagogue',
        label: 'בית כנסת',
        icon: SynagogueIcon,
        description: 'מתאים למוסד הקהילה, מקום התפילה'
    },
    // ── מכובדות / יוקרה / מלכות ──────────────────────────────────────────
    {
        id: 'gavel',
        label: 'פטיש שופט',
        icon: GavelIcon,
        description: 'מתאים לסמכות, כבוד וחוק'
    },
    {
        id: 'balance',
        label: 'מאזניים',
        icon: BalanceIcon,
        description: 'מתאים לצדק, יושר ומאזן'
    },
    {
        id: 'shield',
        label: 'מגן כבוד',
        icon: ShieldIcon,
        description: 'מתאים לנדיב, מגן הקהילה, יוקרה'
    },
    {
        id: 'flare',
        label: 'קרן הוד',
        icon: FlareIcon,
        description: 'מתאים להוד והדר, זוהר ומלכות'
    },
    {
        id: 'vintage',
        label: 'עיטור',
        icon: FilterVintageIcon,
        description: 'מתאים לעיצוב מכובד ומקושט, אות כבוד'
    },
    {
        id: 'spa',
        label: 'פרח טהרה',
        icon: SpaIcon,
        description: 'מתאים לטוהר, רוממות ויופי'
    },
    {
        id: 'candle',
        label: 'נר חכמה',
        icon: WbIncandescentIcon,
        description: 'מתאים לאור תורה, חכמה ויקרה'
    },
    {
        id: 'anchor',
        label: 'עוגן',
        icon: AnchorIcon,
        description: 'מתאים ליציבות, אמינות ויסוד הקהילה'
    },
    {
        id: 'lightbulb',
        label: 'נר השראה',
        icon: LightbulbIcon,
        description: 'מתאים לחכמה, השראה ובהירות'
    },
    {
        id: 'grade',
        label: 'כוכב הוד',
        icon: GradeIcon,
        description: 'מתאים להוקרה מיוחדת, כוכב יוקרה'
    },
    // ── כתרים ──────────────────────────────────────────────────────────────
    {
        id: 'crown_classic',
        label: 'כתר קלאסי',
        icon: CrownClassicIcon,
        description: 'כתר שלושה שיאים — סמל מלכות ויוקרה'
    },
    {
        id: 'crown_royal',
        label: 'כתר מלכותי',
        icon: CrownRoyalIcon,
        description: 'כתר חמישה שיאים — מלכות וגדולה'
    },
    {
        id: 'crown_ornate',
        label: 'כתר מפואר',
        icon: CrownOrnateIcon,
        description: 'כתר מעוטר עם גולות — הוד והדר'
    },
];

/**
 * מחזיר את רכיב האייקון לפי ID
 */
export const getIconById = (iconId) => {
    const option = iconOptions.find(opt => opt.id === iconId);
    return option ? option.icon : StarIcon; // ברירת מחדל: כוכב
};

/**
 * מחזיר את האייקון הראשון (כוכב) כברירת מחדל
 */
export const getDefaultIcon = () => iconOptions[0];
